import React, { useContext } from 'react'
import beginFormCss from 'styles/beginForm.module.scss'
import { ModalContext } from 'providers/Modal'
import { religionOptionsLib, motherTongueOptionsLib } from 'utils/commonLib'
import Dropdown from 'react-dropdown'
import 'styles/beginForm.scss'
import 'react-dropdown/style.css'
import 'styles/dropDownOverrrides.css'

const genderOptions = ['Woman', 'Man']
const defaultGenderOption = genderOptions[0]

const ageOptions = Array.from({ length: 54 }, (_, i) => i + 18).map(num =>
  String(num)
)

const religionOptions = domainReligion => [
  domainReligion,
  ...((domainReligion === 'Select' && religionOptionsLib) || []),
]

const motherTongueOptions = domainLanguage => [
  domainLanguage,
  ...((domainLanguage === 'Select' && motherTongueOptionsLib) || []),
]

const BeginForm = props => {
  const { setActive } = useContext(ModalContext)

  return (
    <div className="form-wrapper">
      <form className={beginFormCss.form}>
        <div className="form-row">
          <div className="form-group col-md-2 col-6">
            <label className="label" htmlFor="lookingFor">
              I'm looking for a
            </label>
            <Dropdown
              options={genderOptions}
              value={defaultGenderOption}
              placeholder={defaultGenderOption}
            />
          </div>
          <div className="form-group col-md-3 col-6">
            <label className="label">aged</label>
            <div className="ageWrap">
              <div className="ageFrom">
                <Dropdown
                  options={ageOptions}
                  value={ageOptions[2]}
                  placeholder={ageOptions[2]}
                />
              </div>
              <div className="ageTo">to</div>
              <div className="ageUpto">
                <Dropdown
                  options={ageOptions}
                  value={ageOptions[7]}
                  placeholder={ageOptions[2]}
                />
              </div>
            </div>
          </div>
          <div className="form-group col-md-2 col-6">
            <label className="label" htmlFor="inputPassword4">
              of religion
            </label>
            <Dropdown
              options={religionOptions(props.domainReligion)}
              value={props.domainReligion}
              placeholder={props.domainReligion}
            />
          </div>
          <div className="form-group col-md-3 col-6">
            <label className="label" htmlFor="inputPassword4">
              and mother tongue
            </label>
            <Dropdown
              options={motherTongueOptions(props.domainLanguage)}
              value={props.domainLanguage}
              placeholder={props.domainLanguage}
            />
          </div>
          <div className="form-group col-md-2 col-12 btnWrap">
            <label className="label btnLable" htmlFor="inputPassword4">
              &nbsp;
            </label>
            <button
              data-testid="lets_begin"
              type="button"
              onClick={() => setActive('register')}
              className="btn btn-primary form-control brand"
            >
              Let's Begin
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default BeginForm
